function cloneEvent(event) {
    return new event.constructor(event.type, event);
}

export { cloneEvent };
